import { render, staticRenderFns } from "./FlyerWindow.vue?vue&type=template&id=b9c466a2&scoped=true&"
import script from "./FlyerWindow.vue?vue&type=script&lang=js&"
export * from "./FlyerWindow.vue?vue&type=script&lang=js&"
import style0 from "./FlyerWindow.vue?vue&type=style&index=0&id=b9c466a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c466a2",
  null
  
)

export default component.exports